import { useEffect, useState } from 'react';
import PAJAA020 from '../../../pages/MyPage/PAJAA020';
import { getCommonInfo } from '../../../services/Api';

const withSecondPassword = (Component) => {
    return (props) => {
        const [isAuthenticated, setIsAuthenticated] = useState(false);
        const [isLoading, setIsLoading] = useState(true);

        useEffect(() => {
            const fetchCommonInfo = async () => {
                try {
                    const authPassVerified = sessionStorage.getItem('authPassVerified');
                    if (authPassVerified === 'true') {
                        setIsAuthenticated(true);
                        return;
                    }

                    const { data } = await getCommonInfo();
                    setIsAuthenticated(data.checkSecondPassSet === 'N');
                } catch (error) {
                    console.log(error);
                } finally {
                    setIsLoading(false);
                }
            };

            fetchCommonInfo();
        }, []);

        const handleAuthentication = (status) => {
            setIsAuthenticated(status);
        };

        if (isLoading) {
            return null;
        }

        if (!isAuthenticated) {
            return <PAJAA020 onAuthenticate={handleAuthentication} />;
        }

        return <Component {...props} />;
    };
};

export default withSecondPassword;
